
import PrintReportStatistics from "./PrintDailyReports";

// ✅ تستقبل sessions + options (أو كـ payload { sessions, options }) وتطبع على نافذة جديدة
export const ReportStatisticsUtils = async (sessions = [], options = {}) => {
  // دعم استدعاء بديل: ReportStatisticsUtils({ sessions, options })
  if (sessions && typeof sessions === "object" && !Array.isArray(sessions) && sessions.sessions) {
    const payload = sessions;
    sessions = Array.isArray(payload.sessions) ? payload.sessions : [];
    options = payload.options || {};
  }

  const printWindow = window.open("", "printWindow", "width=900,height=700");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

    try {
      // set document title if provided
      if (options && options.title) {
        try {
          printWindow.document.title = options.title;
        } catch (e) {}
      }

      // ✅ مهم: مرّر options في المكان الصحيح (الرابع)
      const html = await PrintReportStatistics(sessions, {}, null, options);

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();

    const tryClose = () => {
      try {
        if (printWindow && !printWindow.closed) printWindow.close();
      } catch (e) {}
    };

    printWindow.onafterprint = tryClose;
    try {
      printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
    } catch (e) {}

    const fallbackTimer = setTimeout(() => {
      tryClose();
    }, 12000);

    const pollInterval = setInterval(() => {
      if (!printWindow || printWindow.closed) {
        clearInterval(pollInterval);
        clearTimeout(fallbackTimer);
        try {
          printWindow.onafterprint = null;
          printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
        } catch (e) {}
      }
    }, 500);

    printWindow.print();
  } catch (err) {
    console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
    alert("فشل في تجهيز تقرير الطباعة.");
    try {
      if (!printWindow.closed) printWindow.close();
    } catch (e) {}
  }
};
